import { post } from "@libs:axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

export interface DocumentTranslation {
  POST: {
    RequestBody: {
      file: File;
      targetLanguage: string;
    };
    Response: Blob;
  };
}

export const useMutationTranslateDocument = (
  botId: string,
  options?: UseMutationOptions<
    DocumentTranslation["POST"]["Response"],
    AxiosError,
    DocumentTranslation["POST"]["RequestBody"]
  >,
) => {
  return useMutation({
    mutationFn: async (
      data: DocumentTranslation["POST"]["RequestBody"],
    ): Promise<Blob> => {
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("target_language", data.targetLanguage);

      const response = await post("/api/translation/document", formData, {
        params: { botId },
        responseType: "blob",
      });

      return response as Blob;
    },
    ...options,
  });
};
